<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid login-orders-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Logins Report</h4>
            <hr />

            <div class="mt-2">
              <div>
                <label style="font-size: 16px">Logins Report</label>
              </div>
              <div>
                <strong>Start Date: </strong>
                <span>
                  {{
                    moment(this.$route.params.start_date).format("MM/DD/YYYY")
                  }}</span
                >
              </div>

              <div>
                <strong>End Date: </strong>
                <span>{{
                  moment(this.$route.params.end_date).format("MM/DD/YYYY")
                }}</span>
              </div>

              <div>
                <strong>Total Logins: </strong>
                <span v-if="this.loginsOrdersReport.totalRecords == null"
                  >0</span
                >
                <span v-else>
                  {{
                    this.loginsOrdersReport.totalRecords.toLocaleString()
                  }}</span
                >
              </div>
            </div>
            <div v-if="loading === true">
              <div>
                <div class="centered">
                  <a-spin />
                </div>
              </div>
            </div>
            <div v-else>
              <div
                class="d-flex justify-content-between align-items-center mt-3"
              >
                <p class="mb-0 pl-2">
                  Click on any column header to sort on that column. Click again
                  to reverse order.
                </p>
                <div class="d-inline-flex pr-2">
                  <div>
                    <label class="mt-1">Show </label>
                  </div>
                  <div class="ms-2">
                    <b-select
                      class="form-select form-select-sm ml-1"
                      v-model.number="perPage"
                      @change="getLoginsReports"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </b-select>
                  </div>
                  <div class="ml-2 ms-2">
                    <label class="mt-1">entries</label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-hover mt-2 table-bordered border-light"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('FIRSTNAME')"
                      >
                        <span>First Name</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('LASTNAME')"
                      >
                        <span>Last Name</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('EMAIL')"
                      >
                        <span>Email</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('CLIENTNAME')"
                      >
                        <span>Client</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('PLATFORM')"
                      >
                        <span>Platform</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('PLATFORMVERSION')"
                      >
                        <span>Version</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                      <th
                        scope="col"
                        style="cursor: pointer;"
                        @click="sortClients('EVENTDATE')"
                      >
                        <span>Date</span>
                        <span>&nbsp;<font-awesome-icon icon="sort"/></span>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-if="this.loginsOrdersReport.Result === null">
                      <div>No records found</div>
                    </tr>

                    <tr
                      v-for="(login, index) in this.loginsOrdersReport.Result"
                      :key="index"
                    >
                      <td>{{ login.first_name }}</td>
                      <td>{{ login.last_name }}</td>
                      <td>{{ login.email }}</td>
                      <td>{{ login.client_name }}</td>
                      <td>{{ login.platform }}</td>
                      <td>{{ login.version }}</td>
                      <td>{{ login.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex justify-content-between mt-2">
                <div>
                  <span v-if="loginsOrdersReport.Result === null"
                    >Showing 0 to 0 of 0 entries</span
                  >
                  <span v-else
                    >Showing
                    {{ (currentPage - 1) * loginsOrdersReport.pageSize + 1 }}
                    to
                    {{
                      (currentPage - 1) * loginsOrdersReport.pageSize +
                        loginsOrdersReport.selectedRecordCount
                    }}
                    of
                    {{ loginsOrdersReport.totalRecords }} entries</span
                  >
                </div>
                <div v-if="this.loginsOrdersReport.Result">
                  <pagination
                    :data="this.loginsOrdersReport.Result"
                    :totalPages="
                      Math.ceil(this.loginsOrdersReport.totalRecords / perPage)
                    "
                    :total="this.loginsOrdersReport.totalRecords"
                    :perPage="perPage"
                    :currentPage="currentPage"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "LoginReportView",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    pagination: Pagination,
  },

  data() {
    return {
      loading: false,
      perPage: 10,
      currentPage: 1,
      sortField: "",
      sortOrder: "ASC",
    };
  },
  computed: {
    loginsOrdersReport() {
      return this.$store.getters["loginsAndOrdersReport/getLoginsOrdersReport"];
    },
  },
  mounted() {
    this.loginsOrdersReport();
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsLogins&OrdersReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
    onPageChange(page) {
      console.log("page changed", page);
      this.loading = true;
      this.currentPage = page;
      this.$store
        .dispatch("loginsAndOrdersReport/addLoginsOrdersReport", {
          form: this.$route.params.form,
          params: {
            pg_num: this.currentPage,
            pg_size: this.perPage,
            sort_field: this.sortField,
            sort_order: this.sortOrder,
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
    getLoginsReports() {
      this.loading = true;
      this.currentPage = 1;
      this.$store
        .dispatch("loginsAndOrdersReport/addLoginsOrdersReport", {
          form: this.$route.params.form,
          params: {
            pg_num: this.currentPage,
            pg_size: this.perPage,
            sort_field: this.sortField,
            sort_order: this.sortOrder,
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
    sortClients(sortField) {
      this.loading = true;
      this.sortField = sortField;
      this.sortOrder = this.sortOrder === "ASC" ? "DESC" : "ASC";
      this.$store
        .dispatch("loginsAndOrdersReport/addLoginsOrdersReport", {
          form: this.$route.params.form,
          params: {
            pg_num: this.currentPage,
            pg_size: this.perPage,
            sort_field: this.sortField,
            sort_order: this.sortOrder,
          },
        })
        .then(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.login-orders-report {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.centered {
  position: fixed;
  top: 62%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

html,
body {
  height: 100%;
}
</style>
